import moment from "moment";
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null;
  }
  const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
  let date;
  if (typeof time === "object") {
    date = time;
  } else {
    if (typeof time === "string") {
      if (/^[0-9]+$/.test(time)) {
        // support "1548221490638"
        time = parseInt(time);
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), "/");
      }
    }

    if (typeof time === "number" && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  const formatObj = {
    y: `${date.getFullYear()}`.substr(-2),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  };
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === "a") {
      return ["日", "一", "二", "三", "四", "五", "六"][value];
    }
    return value.toString().padStart(2, "0");
  });
  return time_str;
}
export function parseTimeHengGang(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null;
  }
  const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
  let date;
  if (typeof time === "object") {
    date = time;
  } else {
    if (typeof time === "string") {
      if (/^[0-9]+$/.test(time)) {
        // support "1548221490638"
        time = parseInt(time);
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), "/");
      }
    }

    if (typeof time === "number" && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  const formatObj = {
    y: `${date.getFullYear()}`,
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  };
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === "a") {
      return ["日", "一", "二", "三", "四", "五", "六"][value];
    }
    return value.toString().padStart(2, "0");
  });
  return time_str;
}
export function parseTimeGang(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null;
  }
  const format = cFormat || "{y}/{m}/{d} {h}:{i}:{s}";
  let date;
  if (typeof time === "object") {
    date = time;
  } else {
    if (typeof time === "string") {
      if (/^[0-9]+$/.test(time)) {
        // support "1548221490638"a
        time = parseInt(time);
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), "/");
      }
    }

    if (typeof time === "number" && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  const formatObj = {
    y: `${date.getFullYear()}`,
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  };
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === "a") {
      return ["日", "一", "二", "三", "四", "五", "六"][value];
    }
    return value.toString().padStart(2, "0");
  });
  return time_str;
}
export function formatTime(time, option) {
  if (("" + time).length === 10) {
    time = parseInt(time) * 1000;
  } else {
    time = +time;
  }
  const d = new Date(time);
  const now = Date.now();

  const diff = (now - d) / 1000;

  if (diff < 30) {
    return "刚刚";
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + "分钟前";
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + "小时前";
  } else if (diff < 3600 * 24 * 2) {
    return "1天前";
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return (
      d.getMonth() +
      1 +
      "月" +
      d.getDate() +
      "日" +
      d.getHours() +
      "时" +
      d.getMinutes() +
      "分"
    );
  }
}
//防抖实现
export default function debounce(fn,delay){
  let timer = null
  return function() {  //借助闭包
    let th = this;
    let args = arguments;
    if(timer){
      clearTimeout(timer)
    }
    timer = setTimeout(()=>{
      fn.apply(th, args)
    },delay)
  }
}

export function flatten(arr, key) {
  var res = [];
  // arr.forEach(item=>{
  //   if(Array.isArray(item[key])){
  //     res.push(item)
  //     res.concat(flatten(item[key]))
  //   }
  //   else res.push(item)
  // })

  for (var i = 0; i < arr.length; i++) {
    if (Array.isArray(arr[i][key])) {
      res.push(arr[i]);
      res = res.concat(flatten(arr[i][key]));
    } else {
      res.push(arr[i]);
    }
  }
  return res;
}
export function deepClone(source) {
  if (!source && typeof source !== "object") {
    throw new Error("error arguments", "deepClone");
  }
  const targetObj = source.constructor === Array ? [] : {};
  Object.keys(source).forEach((keys) => {
    if (source[keys] && typeof source[keys] === "object") {
      targetObj[keys] = deepClone(source[keys]);
    } else {
      targetObj[keys] = source[keys];
    }
  });
  return targetObj;
}
export function commonObj(arr1, object2) {
  return Object.assign(
    ...arr1.map((key) => {
      if (typeof object2[key] !== "object") {
        return { [key]: object2[key] };
      } else {
        return { [key]: deepClone(object2[key]) };
      }
    })
  );
}
export function toTree(data, id = "id", p = "parent") {
  //删除所有children,防止多次调用
  data.forEach((item) => {
    if (item) delete item.children;
  });
  //将数据存储为以code为key的map索引数据列
  const map = {};
  data.forEach((item) => {
    if (item) map[item[id]] = item;
  });
  const val = [];
  data.forEach((item) => {
    if (item) {
      const parent = map[item[p]];
      if (parent) {
        (parent.children || (parent.children = [])).push(item);
      } else {
        if (item.level == 1) {
          val.push(item);
        }
      }
    }
  });
  return val;
}
export function columnP(key, val, columnOptions) {
  return columnOptions.reduce((acc, cur) => {
    if (cur[val]) {
      acc[cur[key]] = cur[val];
    }
    return acc;
  }, {});
}

export function isObjectValueEqual(a, b, VersionNo) {
  console.log(a, b, VersionNo);
  var aProps = Object.getOwnPropertyNames(a);
  var bProps = Object.getOwnPropertyNames(b);

  if (aProps.length !== bProps.length) {
    return false;
  }

  for (var i = 0; i < aProps.length; i++) {
    var propName = aProps[i];
    var propA = a[propName];
    var propB = b[propName];
    //  console.log(propName);
    if (propName === VersionNo) continue;
    else if (propName == "__ob__") continue;
    else if (propA !== propB) {
      return false;
    }
  }
  return true;
}
export function formatDataTree(data, id = "id", pid = "pid") {
  let _data = JSON.parse(JSON.stringify(data));

  return _data.filter((p) => {
    const _arr = _data.filter((c) => c[pid] === p[id]);
    _arr.length && (p.children = _arr);
    return p.pid === 0;
  });
}
export function turn(arr) {
  return [].concat.apply([], arr);
}
//解析token
export function FormatToken(value) {
  console.log("解析token",value);
  return decodeURIComponent(
    escape(
      window.atob(
        value
          .replace("-", "+")
          .replace("_", "/")
          .replace(/-/g, "+")
          .split(".")[1]
      )
    )
  );

}
export function dealListByDate(list) {
  if(!list) return
  if (Array.isArray(list)) {
    if (!list || list.length == 0) return [];
    const currentTime = moment();
    list.forEach((item) => {
      if (!item) return;
      const startDate = moment(item.StartTime);
      const endDate = moment(item.EndTime);
      if (startDate > currentTime) {
        item.status = "notYet";
        item.tips = `预计${startDate.format("MM月DD日 HH:mm")} 开始`;
      } else if (currentTime < endDate) {
        item.status = "ing";
        let diffHours = endDate.diff(currentTime, "hours", true);
        if (diffHours <= 24) {
          let date =
            moment().date() == moment(endDate).date() ? "今日" : "明日";
          item.tips = `${date} ${endDate.format("HH:mm")} 结束`;
        } else if (diffHours < 25) {
          item.tips = `出价即将进入24小时倒计时`;
        } else {
          item.tips = `${endDate.format("MM月DD日 HH:mm")} 结束`;
        }
      } else {
        item.status = "finish";
        item.tips = item.StatusName || "已结束";
      }
    });
  } else {
    let item = list;
    const currentTime = moment();
    const startDate = moment(item.StartTime);
    const endDate = moment(item.EndTime);
    if (startDate > currentTime) {
      item.status = "notYet";

      item.tips = `预计${startDate.format("MM月DD日 HH:mm")} 开始`;
    } else if (currentTime < endDate) {
      item.status = "ing";
      let diffHours = endDate.diff(currentTime, "hours", true);
      if (diffHours <= 24) {
        let date = moment().date() == moment(endDate).date() ? "今日" : "明日";
        console.log(moment(endDate).date());
        item.tips = `${date} ${endDate.format("HH:mm")} 结束`;
      } else if (diffHours < 25) {
        item.tips = `出价即将进入24小时倒计时`;
      } else {
        item.tips = `${endDate.format("MM月DD日 HH:mm")} 结束`;
      }
    } else {
      item.status = "finish";
      item.tips = item.StatusName || "已结束";
    }
  }
  return list;
  
}
export function throttle(fn, delay=200, minTime=200) {
  if (typeof fn !== "function") return new Function();
  var timer = null;
  var starTime = null;
  return function () {
    var now = +new Date();
    !starTime && (starTime = now);
    if (minTime && now - starTime > minTime) {
      fn();
      starTime = now;
    } else {
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn();
        starTime = null;
      }, delay);
    }
  };
}
